export default __webpack_public_path__ + "static/media/small_mammal.cdcb1548.svg";